import { render, staticRenderFns } from "./CardBacklog.vue?vue&type=template&id=6cf20fb1"
import script from "./CardBacklog.vue?vue&type=script&lang=js"
export * from "./CardBacklog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports